import { useState } from "react";
import Adjuntar from "../../Img/Iconos/AdjuntarArchivo.svg";
import {
  Typography,
  Box,
  Button,
  Alert,
  Divider,
  IconButton,
  Grid,
  CircularProgress,
  Badge
} from '@mui/material';
import { FileWordOutlined } from "@ant-design/icons";
import TextField from '@mui/material/TextField';
import {
  Delete as DeleteIcon,
  Image as ImageIcon,
  PictureAsPdf as PictureAsPdfIcon,
  InsertDriveFile as InsertDriveFileIcon,
} from "@mui/icons-material";

const badgeStyle = {
  '& .MuiBadge-badge': {
    backgroundColor: '#148F9F',
    color: '#fff',
  },
};

export default function InputFileUpload({ formatos, onSubmit, loading }) {
  const Imagenes = {
    input: "image/png,image/jpeg",
    validacion: ["png", "jpeg"]
  };

  const Videos = {
    input: "video/*",
    validacion: []
  };

  const Pdf = {
    input: "application/pdf",
    validacion: ["pdf"]
  };

  const Archivos = {
    input: "image/png,image/jpeg,application/pdf",
    validacion: ["png", "jpeg", "pdf"]
  }

  const Todos = {
    input: ".doc,.docx,image/png,image/jpeg,application/pdf,video/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    validacion: ["png", "jpeg", "pdf", "doc", "docx", "msword", "vnd.openxmlformats-officedocument.wordprocessingml.document"]
  }

  const [TotalMegas, setTotalMegas] = useState(0);
  const [arrayFiles, setArrayFiles] = useState([]);
  const [messageError, setMessageError] = useState({
    show: false,
    message: ""
  });
  const [showAlert, setShowAlert] = useState(false);
  const [notes, setNotes] = useState();

  function selectFormato() {
    if (formatos === 1) {
      return Imagenes.input;
    } else if (formatos === 2) {
      return Videos.input;
    } else if (formatos === 3) {
      return Pdf.input;
    } else if (formatos === 4) {
      return Archivos.input;
    } else if (formatos === 5 || formatos === undefined) {
      return Todos.input;
    }
  }

  function addImagesToArray(e) {
    let indexImg = arrayFiles.length > 0 ? arrayFiles[arrayFiles.length - 1].index + 1 : 0;

    let array_files = e.currentTarget.files;
    let total_temp = 0;
    if (Array.from(e.currentTarget.files).length > 20) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
    Object.keys(array_files).forEach(x => {
      total_temp += array_files[x].size;
    });

    if (total_temp <= 20000000) {
      const files = Array.from(array_files).slice(0, 20);
      const arrayImages = [];

      Object.keys(files).forEach((i) => {
        const file = files[i];

        let url = URL.createObjectURL(file);
        let formato = file.type.split("/");

        let fileSize = ((file.size / 1024) / 1024);
        if (formato[1] === "pdf" || formato[1] === "jpeg" || formato[1] === "png" || formato[1] === "doc" || formato[1] === "docx"
          || formato[1] === "msword" || formato[1] === "vnd.openxmlformats-officedocument.wordprocessingml.document" || formato[1] === "jpg") {
          if (fileSize <= 6) {
            arrayImages.push({
              index: indexImg,
              name: file.name,
              url,
              file,
              size: file.size,
              formato: formato[1],
              tipo: "0",
              sendToPatient: true,
            });

            indexImg++;

            let total = TotalMegas + fileSize;
            let newImgsState = [...arrayFiles, ...arrayImages];
            let newImgsStateCopy = [];
            if (newImgsState.length>20) {
              newImgsStateCopy = newImgsState.slice(0, 20);
              newImgsState = newImgsStateCopy;
            }
            setArrayFiles(newImgsState);
            setTotalMegas(total);
          } else {
              let error = {};
              error.show = true;
              error.message = "El archivo excede el tamaño maximo permitido (6MB)";
              setMessageError(error);
          }

        } else {
          if (formato[0] === "video") {
            if (fileSize <= 10) {
              arrayImages.push({
                index: indexImg,
                name: file.name,
                url,
                file,
                size: file.size,
                formato: formato[1],
                tipo: "0",
                sendToPatient: true,
              });

              let newImgsState = [...arrayFiles, ...arrayImages];
              let newImgsStateCopy = [];
              if (newImgsState.length>20) {
                newImgsStateCopy = newImgsState.slice(0, 20);
                newImgsState = newImgsStateCopy;
              }
              indexImg++;

              setArrayFiles(newImgsState);
              let total = TotalMegas + fileSize;
              setTotalMegas(total);
            } else {
              let error = {};
              error.show = true;
              error.message = "El video excede el tamaño maximo permitido (10MB)";
            }
          } else {
            let error = {};
            error.show = true;
            if (formatos === 1) {
              // console.log("1");
              error.message = "Tipo de archivo no valido. Archivos permitidos: imagenes ( png, jpeg )";
            } else if (formatos === 2) {
              // console.log("2");
              error.message = "Tipo de archivo no valido. Archivos permitidos: videos";
            } else if (formatos === 3) {
              // console.log("3");
              error.message = "Tipo de archivo no valido. Archivos permitidos: archivos (pdf)";
            } else if (formatos === 4) {
              // console.log("4");
              error.message = "Tipo de archivo no valido. Archivos permitidos: imagenes y archivos ( png, jpeg, pdf )"
            } else if (formatos === 5 || formatos === undefined) {
              // console.log("4");
              error.message = "Tipo de archivo no valido. Archivos permitidos: imagenes, archivos y videos ( png, jpeg, pdf, doc, docx )"
            }

            setMessageError(error);
          }
        }
      });
    } else {
      let error = {};
      error.show = true;
      error.message = "El listado de archivos excede el tamaño maximo permitido (20MB)";
    }

    document.getElementById("FilesList").value = "";
  }

  const uploadFiles = (e)=> {
    e.preventDefault();
    if (arrayFiles.length > 0) {
      setMessageError({ show: false, message: "" });
      onSubmit(arrayFiles, notes);
      setArrayFiles([]);
      setTotalMegas(0);
    } else {
      let error = {};
      error.show = true;
      error.message = "Debe seleccionar al menos un archivo para subir";
      setMessageError(error);
    }
  };

  const deleteImg = (index) => {
    const newImgs = arrayFiles.filter(function (element) {
      return element.index !== index;
    });

    if (newImgs.length === 0) {
      document.getElementById("FileArchivoList").value = "";
    }
    setArrayFiles(newImgs);
    return;
  };

  const renderIconFile = (name) =>{
    const documentExtention = name.substring(name.lastIndexOf(".") + 1);
    switch (documentExtention) {
      case 'docx':
      case 'doc':
      case 'dot':
      case 'dotx':
        return <FileWordOutlined style={{ color: '#436170', fontSize: '35px' }} />;
      case 'png':
      case 'jpeg':
      case 'jpg':
        return <ImageIcon sx={{ color: '#436170', fontSize: '35px' }} />;
      case 'pdf':
        return <PictureAsPdfIcon sx={{ color: '#cb5959', fontSize: '35px' }} />
      default:
        return <InsertDriveFileIcon sx={{ color: '#436170', fontSize: '35px' }} />;
    }
  };

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      marginBottom: "10px",
      border: '1px solid rgba(0, 0, 0, 0.12)',
      padding: '10px',
      borderRadius: '5px',
    }} component="form" onSubmit={uploadFiles}>
      <Typography sx={{ marginBottom: '5px' }}>Subir nuevo documento</Typography>
      {
        messageError.show && (
          <Alert sx={{ width: '100%' }} severity="warning">{ messageError.message}</Alert>
        )
      }
      {
      showAlert ? (
        <Alert severity="warning" sx={{ marginBottom: '15px' }}>
          <Typography sx={{ display: 'flex', justifyContent: 'center' }}>
            Solo se permiten máximo 20 archivos.
          </Typography>
        </Alert>
        ) : null
      }
      {
        arrayFiles.length > 0 && (
          <Box sx={{
            width: '100%',
            marginBottom: '10px',

          }}>
            <Typography variant="body2" sx={{ marginBottom: '5px' }}>
              Archivos seleccionados ({arrayFiles.length}):
            </Typography>
            <Box style={{ paddingLeft: '20px', margin: 0 }}>
              {arrayFiles.map((file, index) => (
                <>
                  <Grid container key={index} sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', with: '100%' }}>
                    <Grid item xs={2}>
                      <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                        <Badge badgeContent={index + 1}   sx={badgeStyle}>
                          {renderIconFile(file.name)}
                        </Badge>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ width: '100px'}}>
                      <Typography variant="caption" gutterBottom sx={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {file.name}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                        ({(file.size / 1024 / 1024).toFixed(2)} MB)
                      </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <IconButton aria-label="delete" onClick={() => deleteImg(file.index)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Divider />
                </>
              ))}
            </Box>
          </Box>
        )
      }
      <TextField
        size="small"
        label="Notas"
        rows={4}
        multiline
        variant="outlined"
        fullWidth
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&:hover fieldset': {
              borderColor: '#1677ff',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1677ff',
            },
          },
          '& label.Mui-focused': {
            color: '#1677ff',
          },
        }}
      />
      <label htmlFor="FilesList"
        style={{ cursor: "pointer", marginBottom: '15px', marginTop: '10px' }}>
        <img style={{ width: "16px" }} src={Adjuntar} alt="" />
        <b>Adjuntar</b>
        <input
          hidden={true}
          id="FilesList"
          type="file"
          accept={`${selectFormato}`}
          onChange={(e) => {
            addImagesToArray(e);
          }}
          style={{ display: "none" }}
          multiple
        />
      </label>
        <Button
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: 'rgb(20, 143, 159)',
            color: '#fff',
            '&:hover': {
                backgroundColor: 'rgb(21 159 177)', // o cualquier color
            }
          }}
          type="submit"
          size="small"
          
        >
          Guardar
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              color: 'rgb(20, 143, 159)',
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
        </Button>
    </Box>
  );
}
